import React from 'react';
import { useIntl } from 'react-intl';
import { shallowEqual, useSelector } from 'react-redux';

import type { RootState } from '@swf/core/store';
import { useSAGGameUrl, useSAGHandleRegisterOpened } from '@swf/poker';

import { usePokerPowerPathWidget } from '../../model';
import type { StepKey } from '../../types';
import { getPrizePoolLabel } from '../../utils/prizePool';
import Tile from '../Tile/Tile';

import { TXTCLI_Gold_Pass, TXTCLI_ON_DEMAND, TXTCLI_Play_Now } from './StepOnDemand.messages.json';
import { TILE_BANNER_CLASSES_MAP } from './constants';

interface Props {
  stepKey: StepKey;
}

const StepOnDemand: React.FC<Props> = ({ stepKey }) => {
  const { formatMessage } = useIntl();
  const { widgetSelect } = usePokerPowerPathWidget();
  const selectedStep = useSelector(
    (rootState: RootState) => widgetSelect.getStepByKey(rootState, stepKey),
    shallowEqual
  );

  const tableUrl = useSAGGameUrl({
    isFlash: false,
    isMax: false,
    scriptId: selectedStep?.id ?? 0
  });

  const handleOnRegister = useSAGHandleRegisterOpened({
    tableUrl,
    tileScriptId: selectedStep?.id ?? 0,
    shouldCloseOldModalFirst: false,
    isFlash: false
  });

  if (!selectedStep) {
    return null;
  }

  const { key, formattedBuyIn, step, currency } = selectedStep;
  const formattedPrize = formatMessage(TXTCLI_Gold_Pass);
  const tournamentStatus = formatMessage(TXTCLI_ON_DEMAND);

  return (
    <Tile
      prize={formattedPrize}
      prizeLabel={getPrizePoolLabel(key)}
      status={tournamentStatus}
      buyIn={formattedBuyIn}
      currency={currency}
      stepNumber={step}
      stepKey={key}
      enrolled="3-max"
      onRegister={handleOnRegister}
      bannerClassName={TILE_BANNER_CLASSES_MAP[key]}
      playButtonTranslation={TXTCLI_Play_Now}
    />
  );
};
export default StepOnDemand;
